import { render, staticRenderFns } from "./PageUserLogin.vue?vue&type=template&id=389433ca"
import script from "./PageUserLogin.vue?vue&type=script&lang=js"
export * from "./PageUserLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports